import { Link, Text } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Receivable } from '@finley-technologies/finley-types';

import { Alert } from 'packages/common-frontend/components/Alert';

type Props = { status?: Receivable.Assignment.Pipeline.Status };
export const PipelineStatusAlert = ({ status }: Props) => {
  switch (status) {
    case 'incomplete':
      return (
        <Alert status="warning" isClosable={false}>
          <Text>
            Your recent upload is incomplete. Deliver new tapes via existing
            workflow or on the{' '}
            <Link as={RouterLink} to="/data-pipeline">
              Data Pipeline
            </Link>{' '}
            page.
          </Text>
        </Alert>
      );
    case 'noPipelineRun':
      return (
        <Alert status="warning" isClosable={false}>
          <Text>
            The credit agreement or loan tape dependency graph has been updated.
            Deliver tapes via existing workflow or on the{' '}
            <Link as={RouterLink} to="/data-pipeline">
              Data Pipeline
            </Link>{' '}
            page to proceed with assignment.
          </Text>
        </Alert>
      );
    case 'assigned':
      return (
        <Alert status="success" isClosable={false}>
          <Text>
            The latest tape was assigned. Deliver new tapes via existing
            workflow or on the{' '}
            <Link as={RouterLink} to="/data-pipeline">
              Data Pipeline
            </Link>{' '}
            page to proceed with assignment.
          </Text>
        </Alert>
      );
    case 'success':
      return (
        <Alert status="success" isClosable={false}>
          <Text>The proposed owners have been successfully updated.</Text>
        </Alert>
      );
    case 'error':
      return (
        <Alert status="error" isClosable={false}>
          <Text>
            Your recent upload encountered an error. Please visit the{' '}
            <Link as={RouterLink} to="/data-pipeline">
              Data Pipeline
            </Link>{' '}
            page to learn more.
          </Text>
        </Alert>
      );
    default:
    case 'inProgress':
      return (
        <Alert status="warning" isClosable={false}>
          <Text>
            Your tapes are processing. You will be notified by email when tapes
            are ready to assign.
          </Text>
        </Alert>
      );
  }
};
